import React from 'react'

const FormCheckbox = (props) => {
    // Component-only props — must NOT be spread onto the native <input>.
    // `checked` is destructured out so it's set exactly once below; callers
    // that want an uncontrolled checkbox pass `defaultChecked` instead (e.g.
    // LoginForm's "keep me logged in", PaymentMethodsPage's role toggles),
    // which still flows through via `...rest` untouched. `disabled`/
    // `required` are real DOM attributes already — unlike input.js's
    // isDisabled/isInvalid convention, callers here pass them directly
    // (e.g. ProfilePage's `disabled={!phoneNumber}`), so they're left in
    // `...rest` rather than renamed.
    const {
        idValue,
        isInvalid,
        className,
        label,
        checked,
        showLabel,
        showOptionalLabel,
        ...rest
    } = props;
    const baseClasses = 'peer h-4 w-4 rounded border-gray-400 text-gray-900 shadow-sm focus:ring-gray-900 invalid:shadow-invalid'
    const combinedClasses = className ? `${baseClasses} ${className}` : baseClasses
    return (
        <div className='flex items-center gap-x-3'>
            {label ? (
                <input
                    {...rest}
                    className={combinedClasses}
                    type="checkbox"
                    id={idValue}
                    checked={checked}
                    aria-invalid={isInvalid}
                />
            ) : null}
            {label ? (
                <label
                    htmlFor={idValue}
                    className='p text-sm text-gray-900 peer-focus:text-black peer-disabled:text-gray-200 peer-invalid:text-red'
                >
                    {label}
                </label>
            ) : null}
        </div>
    )
}

export default FormCheckbox
